@switch (order().status.value) {
  @case (OrderStatus.COMPLETING_DOCUMENTS) {
    <div class="container">
      <onyx-divider variant="modal" edge="top"></onyx-divider>

      <div class="wrapper">
        <onyx-information-heading>
          {{ `${I18N}.areDocumentsComplete` | translate }}
        </onyx-information-heading>

        <div class="wrapper">
          <app-order-modal-documents
            [order]="order()"
            [close$]="close$()"
            [showRequirements]="true"
            [hasRequiredDocuments]="hasRequiredDocuments()"
          ></app-order-modal-documents>

          @let isDisabled = hasRequiredDocuments() && !order().documents.length;
          <onyx-button
            color="green"
            [disabled]="isDisabled"
            [spinner]="loading()"
            (click)="!loading() && !isDisabled ? completeDocuments() : null"
          >
            {{ `${I18N}.confirmUpload` | translate }}
          </onyx-button>
        </div>
      </div>

      <onyx-divider variant="modal" edge="bottom"></onyx-divider>
    </div>
  }

  @case (OrderStatus.INVOICE_TO_ISSUE) {
    @if (showInvoiceForm()) {
      <div class="container">
        <onyx-divider variant="modal" edge="top"></onyx-divider>

        <app-order-modal-invoice-form
          [order]="order()"
          (hideForm)="toggleInvoiceForm()"
        ></app-order-modal-invoice-form>

        <onyx-divider variant="modal" edge="bottom"></onyx-divider>
      </div>
    } @else {
      <div class="content">
        <onyx-button
          [variant]="
            isWaitingForCollectiveInvoiceIssue() ? 'outlined' : 'primary'
          "
          (click)="toggleInvoiceForm()"
        >
          {{ `${I18N}.addInvoice` | translate }}
        </onyx-button>
      </div>
    }
  }

  @case (OrderStatus.WAITING_FOR_PAYMENT)
  @case (OrderStatus.PARTIALLY_PAID) {
    <app-order-modal-payment-form-container
      [order]="order()"
    ></app-order-modal-payment-form-container>
  }

  @case (OrderStatus.PAID) {
    <app-order-modal-payments-history
      [order]="order()"
    ></app-order-modal-payments-history>
  }
}
